if (!customElements.get('endorsement-slider')) {
  class EndorsementSlider extends HTMLElement {
    constructor() {
      super();
      this.currentToggle = null;
    }
    
    connectedCallback() {
      ['touchend', 'click'].forEach((eventType) => {
        this.addEventListener(eventType, (e) => {
          const swiper = this.querySelector('swiper-carousel').swiper;
          const clickedEl = e.target.closest('[data-action="scroll-to"]');     
          
          if (clickedEl) {
            swiper.slideTo(clickedEl.dataset.index);
          }
          
          this.querySelector('[data-action="scroll-to"].active')?.classList.remove('active');
          this.querySelector(`[data-action="scroll-to"][data-index="${swiper.realIndex}"]`)?.classList.add('active');
        });
      });
    }
  }
  
  customElements.define('endorsement-slider', EndorsementSlider);
}